import React, { createContext, useState } from "react";


export const PlaygroundContext = createContext({});

const PlaygroundProvider = ({ children }) => {
  const [currentSdk, setCurrentSdk] = useState("JavaScript/TypeScript");
  const [currentFeature, setCurrentFeature] = useState("");

  return (
    <PlaygroundContext.Provider
      value={{
        currentSdk,
        setCurrentSdk,
        currentFeature,
        setCurrentFeature,
      }}
    >
      {children}
    </PlaygroundContext.Provider>
  );
};

export default PlaygroundProvider;
